---
title: "Resist the beginnings"
slug: "resist-the-beginnings"
date: "2025-06-13"
excerpt: "As a German student in 2016/17 studying in the U.S., I remember a vivid conversation with one of our American professors at the University of West Florida. We were discussing the rise of Donald Trump during the presidential campaign."
metaTitle: "Resist the beginnings - Lessons from History | Kevin Rassner"
metaDescription: "Reflecting on a conversation about the rise of Donald Trump and the warning signs of authoritarianism from a German perspective. 'Wehret den Anfängen' - Resist the beginnings."
language: "en"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7339163077927428096"
isLinkedInPost: true
---

„Resist the beginnings.“

As a German student in 2016/17 studying in the U.S., I remember a vivid conversation with one of our American professors at the University of West Florida. We were discussing the rise of Donald Trump during the presidential campaign.

The professor made a point I respected: comparing people to Nazis or Hitler usually shuts down dialogue - and should be avoided in good-faith debate.

But where we disagreed was on the warning signs.

To him, Trump seemed like a narcissistic, misogynistic populist at worst, not someone who fit the mold of 20th-century fascist dictators. He judged Trump against the endpoint of historical fascism: state violence, propaganda, media suppression, genocide.

From our German perspective, shaped by the stories of our grandparents, we saw things differently. Dictatorships don't start with concentration camps on day one - They start with charisma, resentment, and promises to restore greatness.

The signs, however, are always there for those who know where to look. In Germany, we have a saying rooted in Latin, „Wehret den Anfängen“ - „Resist the beginnings.“ It is a lesson learned from a history where waiting for the 'worst' to happen meant it was already too late.

It is a difficult thing to risk standing against something that isn't yet a five-alarm fire. I understand the hesitation. But by the time the flames are high enough for all to see, the means to fight back - a free press, an independent judiciary, the very ability to dissent - may already be weakened, censored, or reframed as unpatriotic. This is a known tactic of authoritarian movements.

I can't help but wonder what my former professor thinks now, watching the political landscape in the United States. Do our conversations from years ago ever cross his mind?

